// extracted by mini-css-extract-plugin
export var card = "styles-module--card--83999";
export var cardBody = "styles-module--cardBody--fe75a";
export var cardTitle = "styles-module--cardTitle--f6bb1";
export var cards = "styles-module--cards--0822f";
export var container = "styles-module--container--00ba5";
export var icon = "styles-module--icon--60f0a";
export var section = "styles-module--section--333a0";
export var title = "styles-module--title--7acc1";